import { padStart, reduce } from 'lodash';

export const encodeToChars = (string: $TSFixMe) =>
    reduce(string, (enc, char) => `${enc}${padStart(char.charCodeAt(0).toString(10), 3, '0')}`, '');
